import Splide from '@splidejs/splide';
import { splideA11yOptions, fixSplideSlideRoles } from '@resources/js/splide-a11y';

const padNumber = (number) => {
    const paddedNumber = '0' + number;
    return paddedNumber.substring(paddedNumber.length - 2);
};

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.gallery-section .splide').forEach(function(splideRoot) {
        const splide = new Splide(splideRoot, {
            type: 'loop',
            perPage: 1,
            autoWidth: true,
            gap: '2rem',
            focus: 'center',
            pagination: false,
            autoplay: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            interval: 8000,
            ...splideA11yOptions('Image gallery'),
        });

        const customPageNumbers = splideRoot.querySelector('.splide__page-numbers');
        const currentPage = customPageNumbers?.querySelector('.splide-page-numbers__active');

        const getSlides = () => splideRoot.querySelectorAll('.splide__slide:not(.splide__slide--clone)');

        const updateCurrentPage = (index) => {
            if (currentPage) {
                currentPage.innerText = padNumber(index + 1);
            }
        };

        splide.on('move', (newIndex, prevIndex) => {
            const slides = getSlides();
            const nextSlide = slides[newIndex];
            const prevSlide = slides[prevIndex];

            if (nextSlide) {
                nextSlide.classList.add('is-moving');
            }
            if (prevSlide) {
                prevSlide.classList.add('is-moving');
            }
        });

        splide.on('moved', (newIndex) => {
            getSlides().forEach(slide => slide.classList.remove('is-moving'));
            updateCurrentPage(newIndex);
        });

        splide.on('ready', () => {
            updateCurrentPage(splide.index);
        });

        fixSplideSlideRoles(splide);
        splide.mount();
    });
});
